import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function MSFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <defs>
          <mask id="mantine-bt795952a" fill="#fff">
            <path fillRule="evenodd" d="M0 0h32v24H0z" />
          </mask>
          <mask id="mantine-km5r4dsok" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-x0agswppt" />
          </mask>
          <mask id="mantine-bcfl4r12y" fill="#fff">
            <path
              fillRule="evenodd"
              d="M1.047.033c0 7.072-.45 11.931 4.882 11.931S11.26 5.998 10.907.033z"
            />
          </mask>
          <mask id="mantine-npxwbawj8" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-oauen62le" />
          </mask>
          <path id="mantine-x0agswppt" d="M0 0h32v24H0z" />
          <path id="mantine-oauen62le" d="M0 0h18v14H0z" />
        </defs>
        <g fill="none" fillRule="evenodd" mask="url(#mantine-bt795952a)">
          <use fill="#2e42a5" xlinkHref="#mantine-x0agswppt" />
          <g mask="url(#mantine-km5r4dsok)">
            <path
              stroke="#f7fcff"
              strokeWidth=".5"
              d="M30.672 10.283c.19 3.287.26 6.552-.665 8.768-.354.849-.856 1.54-1.566 2.004-.653.426-1.477.659-2.512.659-.94 0-1.693-.154-2.293-.456-.62-.31-1.073-.777-1.407-1.379-.84-1.516-.937-3.857-.942-6.749v-.59l.005-.971.005-1.286z"
            />
            <g mask="url(#mantine-bcfl4r12y)" transform="translate(20 10)">
              <path fill="#2ebed7" d="M.933 0h10.07v7.978H.933z" />
              <path fill="#a95601" d="M.8 7.914h10.6V12H.8z" />
              <path
                stroke="#ffc6b5"
                d="M6.746 3.464c-1.245.282-1.807.282-1.687 0 .12-.283.342-.933.664-1.95"
              />
              <path
                fill="#ffc6b5"
                d="M7.307 3.766a.655.655 0 01-.34-.59c0-.38-.831-.521-.245-1.115.585-.594.838-.333.838 0 0 .332.47 1.116.47 1.116l-.723.589z"
              />
              <path
                fill="#272727"
                d="M6.365.324v.908H8.22v.909H6.365v7.913h-.927V2.14H3.583v-.908h1.855V.324z"
              />
              <path
                fill="#0c7c38"
                d="M8.362 10.321c-.225-1.04-.337-1.918-.337-2.63 0-1.07-.566-1.834-.404-2.399.161-.565.55-1.19.356-1.577-.195-.387.19-.575-.356-.387s-.693-.188-1.22 0-.594 1.078-.594 1.331.235 1.965.235 2.498-.193 3.814.36 3.814c.552 0 1.154-.854 1.365-.854.14 0 .338.068.595.204z"
              />
              <path
                stroke="#ff9a06"
                d="M5.03 6.141c-.337 0-.027.783-.884 1.126-.857.343-1.026.826-.756.826.18 0 .982.8 2.405 2.398l.524-.809V7.127c-.635-.657-1.065-.986-1.29-.986z"
              />
              <path stroke="#979797" d="M7.543 10.158c.267.572.267.858 0 .858" />
              <path
                stroke="#ffc6b5"
                d="M7.414 3.79c-.117.642-.287 1.03-.51 1.165-.334.201-1.709.591-1.709.925 0 .222-.045.373-.136.452"
              />
              <path
                fill="#ff9a06"
                d="M6.748 1.803c.224.266.399.619.525 1.058.188.659.733.883.733.575 0-.308.404-1.633 0-1.633H6.748z"
              />
            </g>
          </g>
          <g mask="url(#mantine-km5r4dsok)">
            <use fill="#2b409a" xlinkHref="#mantine-oauen62le" />
            <g mask="url(#mantine-npxwbawj8)">
              <g fillRule="nonzero">
                <path
                  fill="#f7fcff"
                  d="M-2.004 13l3.96 1.737L18.09 1.889l2.09-2.582-4.236-.58-6.58 5.536-5.297 3.73z"
                />
                <path fill="#f50100" d="M-1.462 14.217l2.018 1.008L19.429-.933h-2.833z" />
                <path
                  fill="#f7fcff"
                  d="M20.004 13l-3.96 1.737L-.09 1.889-2.18-.693l4.236-.58 6.58 5.536 5.297 3.73z"
                />
                <path
                  fill="#f50100"
                  d="M19.87 13.873l-2.019 1.008-8.036-6.917-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.926z"
                />
              </g>
              <path
                fill="#f50100"
                stroke="#f7fcff"
                strokeWidth="1.5"
                d="M10.735-.75v6h8.015v3.5h-8.016v6h-3.5v-6H-.75v-3.5h7.984v-6z"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
